import * as apiUrl from "../../apiUrl";



export const fetchWhyMarquisPageData = async () => {
  try {
    const endpoints = [
      "/api/why-marquis/banner-section",
      "/api/why-marquis/second-section",     
    ];

    const fetchPromises = endpoints.map(async (endpoint) => {
      const url = apiUrl.apiUrl + endpoint;
      const response = await fetch(url);
      if (!response.ok) {
        console.error(`Failed to fetch ${url}: Status ${response.status}`);
        throw new Error(`HTTP error ${response.status}`);
      }
      return response.json();
    });

    const [
      banner,
      second,          
    ] = await Promise.all(fetchPromises);

    return { banner, second };
  } catch (error) {
    console.error("Error fetching Why Marquis page data:", error);
    return null;
  }
};


